let initialState = {
	saving: false,
	lastSaved: "",
};

export const autoSave = (state = initialState, action) => {
	switch (action.type) {
		case "UPDATE_AUTO_SAVE":
			return {
				...state,
				saving: action.saving,
			};

		case "UPDATE_LAST_SAVED":
			return {
				...state,
				lastSaved: action.lastSaved,
			};

		default:
			return state;
	}
};
